import { useEffect } from 'react'

export default function useRefreshGeolocationPositionIfPermissionGranted({
    geolocationPermission,
    geolocationPosition,
    refreshGeolocationPosition,
}) {
    useEffect(() => {
        // init permission status
        if (!geolocationPermission.status) {
            geolocationPermission.refreshStatus()
            return
        }

        // eagerly init position if permission already granted
        if (
            !geolocationPosition &&
            geolocationPermission.status?.state === 'granted'
        ) {
            refreshGeolocationPosition()
        }
    }, [geolocationPosition, geolocationPermission.status])
}
